var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimEllipsis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 74.995117 53.314453 C 79.194336 53.314453 82.563354 49.945313 82.563354 45.746094 C 82.563354 41.546875 79.194336 38.177734 74.995117 38.177734 C 70.844727 38.177734 67.426758 41.546875 67.426758 45.746094 C 67.426758 49.945313 70.844727 53.314453 74.995117 53.314453 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 45.844727 53.314453 C 50.043945 53.314453 53.412964 49.945313 53.412964 45.746094 C 53.412964 41.546875 50.043945 38.177734 45.844727 38.177734 C 41.645508 38.177734 38.276245 41.546875 38.276245 45.746094 C 38.276245 49.945313 41.645508 53.314453 45.844727 53.314453 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 16.694336 53.314453 C 20.893555 53.314453 24.262695 49.945313 24.262695 45.746094 C 24.262695 41.546875 20.893555 38.177734 16.694336 38.177734 C 12.495117 38.177734 9.125977 41.546875 9.125977 45.746094 C 9.125977 49.945313 12.495117 53.314453 16.694336 53.314453 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimEllipsis);
export default __webpack_public_path__ + "static/media/sim-ellipsis.55e012ec1e085edd7452f3fac45716ff.svg";
export { ForwardRef as ReactComponent };